var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88251 6.15064C4.00864 7.04829 2.08332 7.97066 0.32273 9.03463C-0.596577 9.77314 0.625245 10.2956 1.77155 10.7856C1.95378 10.8635 2.13406 10.9405 2.30358 11.0175C2.44466 11.0651 2.58807 11.1152 2.73343 11.166C4.00832 11.6116 5.42983 12.1086 6.66754 11.3611C8.70073 10.0796 10.6194 8.59816 12.5367 7.11782C13.1648 6.63278 13.7928 6.14791 14.4246 5.67022C14.4542 5.64944 14.4876 5.62567 14.5242 5.59976C15.0623 5.21691 16.2729 4.35603 15.8251 5.54229C14.7663 6.8127 13.6322 7.93722 12.492 9.06798C11.7235 9.83001 10.9522 10.5949 10.1992 11.409C9.54352 11.9935 8.86254 13.1691 9.59683 13.9877C11.2881 15.2867 13.0058 16.5542 14.7224 17.821C15.281 18.2332 15.8397 18.6454 16.3971 19.0586C17.3419 19.8862 18.8185 19.2167 19.0262 17.9235C19.1186 17.3285 19.2113 16.7337 19.3041 16.1388C19.8166 12.851 20.3293 9.562 20.7823 6.26352C20.8438 5.74607 20.9136 5.22871 20.9834 4.71109C21.1526 3.4565 21.3221 2.20037 21.375 0.939026C21.2386 -0.319753 19.8475 -0.0429417 19.0734 0.240112C15.0943 1.90132 11.155 3.68568 7.23122 5.5015C6.78671 5.71751 6.33613 5.93335 5.88251 6.15064Z",
    fill: "#161515"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.54b6126d.svg";
export { ForwardRef as ReactComponent };